import React from 'react';

const CourseSchema = ({ name, description, url }) => {
  // This is the "Business Card" data
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Course",
    "name": name,
    "description": description,
    "provider": {
      "@type": "Organization",
      "name": "Geoinfoacademy",
      "sameAs": "https://geoinfoacademy.com"
    },
    "url": url
  };

  return (
    // This script tag stays invisible to users but Google reads it
    <script type="application/ld+json">
      {JSON.stringify(schemaData)}
    </script>
  );
};

export default CourseSchema;